import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  name: 'development',
  apiUrl: 'https://int-scrims-net-api.talent-np.disney.com/api/',
  apiSsoUrl: 'https://sso.myid.disney.com/app/disney_scrimsnewdevelopment_1/exk1ci95yycI3MbVN0x8/sso/saml',
  clearanceRole: 'SCRIMS Clearance',
  productionRole: 'SCRIMS Production'
};
